const COMAT_Form_Validation = {

  forms : document.querySelectorAll( '[data-comat-form]' ),
  conditions : [],
  classNames : {
    error : 'is-error'
  },

  
  init : function() {

    if ( this.forms ) {

      this.forms.forEach( form => {

        const mode = form.getAttribute( 'data-comat-form' ) ? form.getAttribute( 'data-comat-form' ) : 'dynamic'

        // Setup form conditions tracking
        this.setup.addConditions( form )

        if ( mode === 'dynamic' ) {
            
            this.setup.addListeners( form )

        }

        // Ensure all validation rules are met to allow submit
        form.addEventListener( 'submit', ( event ) => {
          
          if ( !this.isValidSubmission( form ) ) {
            
            // Prevent the submission
            event.preventDefault()

            // Setup the field event listeners for dynamic validation
            if ( mode === 'submit' ) this.setup.addListeners( form )

          }

        } )
  
      } )

    }

  },


  setup : {

    // Find all form fields and look for conditions set as data attributes
    // we'll add validation rules for these conditions
    addConditions : function( form ) {

      const fields = form.querySelectorAll( '[data-comat-form-validation]' )

      if ( fields ) {

        fields.forEach( field => {
          
          field.removeAttribute( 'required' )

          const noticeParentElementID = field.getAttribute( 'data-comat-form-notice-parent' )
          const noticeParentElement = noticeParentElementID ? document.getElementById( noticeParentElementID ) : null

          // Add notice containers
          const noticeContainer = document.createElement('label')
          noticeContainer.classList.add( 'field-validation-container' )
          noticeContainer.setAttribute( 'for', field.getAttribute('id') )
          noticeContainer.style.display = 'none'
          noticeContainer.setAttribute( 'aria-hidden', 'true' )

          // Maybe use a different element for insertion of the field validation notice
          if ( noticeParentElement ) {
            noticeParentElement.append( noticeContainer )
          } else {
            field.parentNode.insertBefore( noticeContainer, field.nextElementSibling )
          }

          // Get the field validation rules
          const rules = field.getAttribute('data-comat-form-validation').split('|')

          // Setup tests based on rules
          if ( rules ) {
            rules.forEach( rule => {
              COMAT_Form_Validation.conditions.push( {
                form: form,
                field: field,
                rule: rule,
                passed: false
              } )
            } )
          }
        } )
      }

    },
    
    // Add relevant event listeners for each condition
    addListeners : function( form ) {

      const fields = form.querySelectorAll( '[data-comat-form-validation]' )

      if ( fields ) {
        fields.forEach( field => {

          const rules = field.getAttribute('data-comat-form-validation').split('|')

          // Add tests and validators
          if ( rules ) {
            rules.forEach( rule => {
              if ( rule === 'required' ) this.addRequiredTextFieldListeners( form, field )
              if ( rule === 'email' )    this.addValidEmailListeners( form, field )
              if ( rule === 'match' )    this.addFieldMatchListeners( form, field )
              if ( rule === 'password' ) this.addPasswordCriteriaListeners( form, field )
            } )
          }

        })
      }

    },

    addRequiredTextFieldListeners : function( form, field ) {

      const interactions = [ 'blur', 'keyup' ]
  
      interactions.forEach( interaction => {
        field.addEventListener( interaction, () => {
          if ( field.value.trim() === '' && interaction === 'keyup' ) {
            // Do nothing in this case
          } else {
            COMAT_Form_Validation.test.runAll( form, field, [ 'email' ] )
          }
        } )
      } )

    },

    addValidEmailListeners : function( form, field ) {

      const interactions = [ 'blur', 'keyup' ]

      interactions.forEach( interaction => {
        field.addEventListener( interaction, () => {
          if ( interaction === 'keyup' && !field.nextElementSibling.hasAttribute( 'style' ) ) {
            // Do nothing in this case
          } else {
            COMAT_Form_Validation.test.runAll( form, field )
          }
        } )
      } )

    },

    addFieldMatchListeners : function ( form, field ) {

      const interactions = [ 'blur' ]

      interactions.forEach( interaction => {
        field.addEventListener( interaction, () => {
          if ( field.value.trim() != '' ) {
            COMAT_Form_Validation.test.runAll( form, field )
          }
        } )
      } )

    },

    addPasswordCriteriaListeners : function ( form, field ) {

      const interactions = [ 'blur', 'keyup' ]

      interactions.forEach( interaction => {
        field.addEventListener( interaction, () => {
          COMAT_Form_Validation.test.runAll( form, field )
        } )
      } )

    }

  },


  validate : {

    requiredText : function( form, field, rule ) {

      const fieldIsValid = ( field.value.trim() === '' ) ? false : true

      COMAT_Form_Validation.conditions.forEach( test => {
        if ( test.form === form && test.field === field && test.rule === rule ) {
          test.passed = fieldIsValid
        }
      } )
  
      COMAT_Form_Validation.displayFieldNotices( field, rule, 'This field is required.' )

    },

    validEmail : function( form, field, rule ) {

      const fieldIsValid = ( /^\S+@\S+\.\S+$/.test( field.value ) ) ? true : false

      COMAT_Form_Validation.conditions.forEach( test => {
        if ( test.form === form && test.field === field && 1 ) {
          test.passed = fieldIsValid
        }
      } )
  
      COMAT_Form_Validation.displayFieldNotices( field, rule, 'Please provide a valid email address.' )

    },

    validFieldMatch : function( form, field, rule ) {

      const matchFieldReference = field.getAttribute( 'data-comat-form-field-match' )
      const matchField = document.getElementById( matchFieldReference )
      const noticeText = field.getAttribute( 'data-comat-form-notice-text' )

      const fieldIsValid = ( matchField.value === field.value && matchField.value.trim() !== '' ) ? true : false

      COMAT_Form_Validation.conditions.forEach( test => {
        if ( test.form === form && test.field === field && test.rule === rule ) {
          test.passed = fieldIsValid
        }
      } )

      COMAT_Form_Validation.displayFieldNotices( field, rule, noticeText )

    },

    validatePasswordCriteria : function( form, field, rule ) {

      const feedbackcontainer = document.getElementById( field.getAttribute('data-comat-form-feedback-container') )

      const isValidLength  = field.value.match( "^.{10,20}$" ) ? true : false         // must be 10-20 characters long
      const isValidLower   = field.value.match( "(?=.*[a-z])" ) ? true : false        // must have a lowercase letter
      const isValidUpper   = field.value.match( "(?=.*[A-Z])" ) ? true : false        // must have an uppercase letter
      const isValidSpecial = field.value.match( "(?=.*[!@#$%^&*-])" ) ? true : false  // must have a special character
      const isValidNmber   = field.value.match( "(?=.*[0-9])" ) ? true : false        // must have a number
      const fieldIsValid   = ( isValidLength && isValidLower && isValidUpper && isValidSpecial && isValidNmber ) ? true : false
      const className      = 'meets-criteria'

      if ( feedbackcontainer ) {
        COMAT_Form_Validation.updateFeedbackContainer( feedbackcontainer, '.js-pw-length', className, isValidLength )
        COMAT_Form_Validation.updateFeedbackContainer( feedbackcontainer, '.js-pw-uppercase', className, isValidUpper )
        COMAT_Form_Validation.updateFeedbackContainer( feedbackcontainer, '.js-pw-lowercase', className, isValidLower )
        COMAT_Form_Validation.updateFeedbackContainer( feedbackcontainer, '.js-pw-number', className, isValidNmber )
        COMAT_Form_Validation.updateFeedbackContainer( feedbackcontainer, '.js-pw-character', className, isValidSpecial )
      }
      
      COMAT_Form_Validation.conditions.forEach( test => {
        if ( test.form === form && test.field === field && test.rule === rule ) {
          test.passed = fieldIsValid
        }
      } )

      // COMAT_Form_Validation.displayFieldNotices( field, rule, 'Password must meet requirements' )

    }

  },


  test : {

    runSingle : function( test ) {

      if ( test.rule === 'required' ) COMAT_Form_Validation.validate.requiredText( test.form, test.field, test.rule )
      if ( test.rule === 'email' )    COMAT_Form_Validation.validate.validEmail( test.form, test.field, test.rule ) 
      if ( test.rule === 'match' )    COMAT_Form_Validation.validate.validFieldMatch( test.form, test.field, test.rule ) 
      if ( test.rule === 'password' ) COMAT_Form_Validation.validate.validatePasswordCriteria( test.form, test.field, test.rule ) 

    },

    runAll : function( form, field, skip = [] ) {
    
      COMAT_Form_Validation.conditions.forEach( test => {
        if ( test.form === form && test.field === field && !skip.includes( test.rule ) ) {
            this.runSingle( test )
        }
      } )

    //   const resetPasswordSubmitButton = document.getElementById( 'resetpass-button' )
    //   if ( resetPasswordSubmitButton ) {
    //     COMAT_Form_Validation.enableSubmitButton( resetPasswordSubmitButton, allFieldsAreValid )
    //   }

    },

    runForm : function( form ) {

      COMAT_Form_Validation.conditions.forEach( test => {
        if ( test.form === form ) { this.runSingle( test ) }
      } )

    }

  },


  updateFeedbackContainer : function( container, selector, className, meetsCriteria ) {

    if ( container ) {
      if ( meetsCriteria ) {
        container.querySelector(selector).classList.add( className )
      } else {
        container.querySelector(selector).classList.remove( className )
      }
    }

  },


  enableSubmitButton: function( button, enabled ) {

    if ( !enabled ) {
        button.setAttribute( 'aria-disabled', 'true' )
    } else {
        button.removeAttribute( 'aria-disabled' )
    }

  },


  displayFieldNotices: function( field, rule, notice ) {

    this.conditions.forEach( test => {
      if ( test.field === field && test.rule === rule ) {

        const noticeParentElementID = field.getAttribute( 'data-comat-form-notice-parent' )
        const noticeParentElement = noticeParentElementID ? document.getElementById( noticeParentElementID ) : null
        const noticeElement = ( noticeParentElement ) ? noticeParentElement.querySelector('.field-validation-container') : field.nextElementSibling
        const validNoticeElement = noticeElement.classList.contains( 'field-validation-container' )

        if ( !test.passed ) {
          field.classList.add( this.classNames.error )
          if ( validNoticeElement ) {
            noticeElement.innerText = notice
            noticeElement.style.display = 'block'
            noticeElement.setAttribute( 'aria-live', 'polite' )
            noticeElement.removeAttribute( 'aria-hidden' )
          }
        } else {
          field.classList.remove( this.classNames.error )
          if ( validNoticeElement ) {
            noticeElement.innerText = ''
            noticeElement.removeAttribute( 'style' )
            noticeElement.removeAttribute( 'aria-live' )
            noticeElement.setAttribute( 'aria-hidden', 'true' )
          }
        }
      }
    } )

  },


  isValidSubmission : function( form ) {

    let isValid = true
    
    // Run all of the tests for the form
    this.test.runForm( form )

    // If any failed set isValid to false
    this.conditions.forEach( test => {
      if ( test.form === form && !test.passed && isValid ) isValid = false
    } )

    // console.log( 'Form is valid: ' +  isValid )

    return isValid
    
  }

}


const COMAT_Password_Field_Toggling = {

    showPasswordLinks : null,

    prepareLoginPasswordField: function() {
        
        const passwordField  = document.getElementById( 'user_pass' )
        const fieldContainer = document.querySelector( '.login-password' )
    
        if ( passwordField ) {

            const height = passwordField.offsetHeight
            const button = document.createElement('button')
            button.setAttribute( 'aria-hidden', 'true' )
            button.setAttribute( 'type', 'button' )
            button.setAttribute( 'data-comat-show-password-link', '.js-toggle-password' )
    
            button.style.height = height + 'px'
            button.style.top = 'auto'
            button.style.bottom = '0'
            button.classList.add( 'show-hide-password-button' )
    
            const svg = `<svg class="responsive-image" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="#7488A8" fill-rule="evenodd"><path d="M12.5 8c3.304 0 6.158 1.838 7.5 4.5-1.34 2.662-4.195 4.5-7.5 4.5-3.305 0-6.159-1.838-7.5-4.5C6.34 9.838 9.195 8 12.5 8Zm0 1.5c-1.706 0-3.088 1.343-3.088 3s1.382 3 3.088 3c1.705 0 3.088-1.343 3.088-3s-1.383-3-3.088-3Z"/><circle cx="12.5" cy="12.5" r="1.5"/></g></svg>`
            const buttonContents = '<span class="screen-reader-text">Show Password</span>' + svg
            
            button.innerHTML = buttonContents
    
            fieldContainer.insertAdjacentElement( 'beforeend', button )
    
        }

    },

    setupPasswordFieldVisibilityToggling: function() {

        this.showPasswordLinks = document.querySelectorAll( '[data-comat-show-password-link]' )

        if ( this.showPasswordLinks ) {
      
            this.showPasswordLinks.forEach( button => {
                
              // The fields to toggle
              const fields = document.querySelectorAll( button.getAttribute('data-comat-show-password-link') )
      
              if ( fields ) {
                button.addEventListener( 'click', () => {
                  const span = button.querySelector('span')
                  fields.forEach( field => {
                    if ( field.getAttribute('type') === 'password' ) {
                      button.classList.add('is-active')
                      span.innerText = 'Hide Password'
                      field.setAttribute( 'type', 'text' )
                    } else {
                      button.classList.remove('is-active')
                      span.innerText = 'Show Password'
                      field.setAttribute( 'type', 'password' )
                    }
                  } )
                } )
              }
      
            } )
          }
      

    },

    init: function() {

        this.prepareLoginPasswordField()
        this.setupPasswordFieldVisibilityToggling()

    }

}


COMAT_Password_Field_Toggling.init()
COMAT_Form_Validation.init()
